'use client'

import color from '@ui/style/color.theme'

interface Icon32CommentProps {
	isDark?: boolean
	isActive?: boolean
}
export const Icon32Comment = ({ isDark, isActive }: Icon32CommentProps) => {
	const colorValue = isDark ? color.colWhite : color.colBlack
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
		>
			{isActive ? (
				<>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M7.09961 6.10001H24.8996V25.9H7.09961V6.10001ZM8.89961 7.90001V24.1H23.0996V7.90001H8.89961Z"
						fill="#052D5A"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M24 7V25H8V7H13H19H24ZM11 12.9016H21V11.1016H11V12.9016ZM21 16.9016H11V15.1016H21V16.9016ZM11 20.9016H16V19.1016H11V20.9016Z"
						fill="#052D5A"
					/>
				</>
			) : (
				<>
					<path
						d="M8 9H24V20.0417H12.4L8 24L8 9Z"
						stroke={colorValue}
						strokeWidth="1.8"
					/>
					<rect x="12.5" y="13.5" width="7" height="1.8" fill={colorValue} />{' '}
				</>
			)}
		</svg>
	)
}
